const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the leave page box component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('leavePageBox', ['$location', function ($location) {
  return {
    restrict: 'E',
    scope: {
      show: '=',
      navigationPath: '=',
      onChange: '&',
      saveContinue: '&',
      newPresentation: '=',
      newWorkshop: '='
    },
    template: require('../../../templates/directives/cms/leave-page-box.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.initialize = function() {

        self.continue = function() {
          $scope.onChange();
          $scope.show = false;
          if ($scope.newWorkshop) {
            return;
          }
          $location.path($scope.navigationPath.targetPath).search($scope.navigationPath.targetSearch).hash($scope.navigationPath.targetHash);
        };
        self.saveContinue = function() {
          if ($scope.newWorkshop) {          
            $scope.saveContinue();
            $scope.show = false;
            return;
          }
          $location.path($scope.navigationPath.targetPath).search($scope.navigationPath.targetSearch).hash($scope.navigationPath.targetHash);
        };
      };


      self.cancel = function() {
        $scope.show = false;
        self.continue = function() {};
      };

      $scope.$watch('show', function(newVal, oldVal) {
        if (newVal && !oldVal) {
          self.initialize();
        }
      });

    }],
    controllerAs: 'navigate'
  };
}]);
